import { render, staticRenderFns } from "./PencilTopBarIcon.vue?vue&type=template&id=5624af26&"
import script from "./PencilTopBarIcon.vue?vue&type=script&lang=js&"
export * from "./PencilTopBarIcon.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports